import MapperBase from '../MapperBase.js';
import BattedBallType from '../../enums/BattedBallType.js';

class MlbBattedBallTypeMapper extends MapperBase {
    constructor(silent) {
        super(silent, BattedBallType.Unidentified.key);
    }

    mapSingle(item) {
        // Unfortunately there is no api doc containing all possible values for this...
        switch (item) {
            case 'bunt_grounder':
            case 'ground_ball':
                return BattedBallType.GroundBall.key;
            case 'fly_ball':
                return BattedBallType.FlyBall.key;
            case 'line_drive':
                return BattedBallType.LineDrive.key;
            case 'popup':
                return BattedBallType.PopUp.key;
        }

        throw new Error(`Unable to map batted ball type ${item}`);
    }
}

export default MlbBattedBallTypeMapper;